import type { PropsWithChildren } from "react";
import {
  getSupportedTabularAggregationTypes,
  supportedTabularAggregations,
} from "../../../../utilities/aggregationHelper.ts";
import { SupportedAggregationsContextProvider } from "../../../viewer/common/context/SupportedAggregationsContextProvider.tsx";

export default function TabularContainer({ children }: PropsWithChildren) {
  return (
    <SupportedAggregationsContextProvider
      aggregations={supportedTabularAggregations}
      getSupportedAggregationTypes={getSupportedTabularAggregationTypes}
    >
      {children}
    </SupportedAggregationsContextProvider>
  );
}
